import { Box, TextField as MuiTextField } from '@mui/material';
import { forwardRef } from 'react';

export const TextareaField = forwardRef(({ rows = 3, value, onChange, ...props }, ref) => (
  <Box sx={{ '& .MuiTextField-root': { width: '100%' } }}>
    <MuiTextField
      fullWidth
      multiline
      ref={ref}
      size="small"
      rows={rows}
      {...props}
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value)}
    />
  </Box>
));

TextareaField.displayName = 'TextareaField';
